export const LINE_SPACING_TYPE = 'line-spacing';
